import React from 'react';
import { Link } from 'react-router';

export default function NoAddress (props) {
  const { alias } = props;
  return (
    <div className="no-address">
      <h2>{alias} doesn't exist yet</h2>
      <h2>
        Reserve it <Link to={`/set?shortcut=${alias}`}>here</Link>
      </h2>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/NoAddress.js